import * as React from 'react';

import styled, { css } from 'styled-components';

import Flex from '@components/layout/flex';

export interface OwnershipBarProps {
  className?: string;
  children: React.ReactElement[];
}

export const OwnershipBar: React.FC<OwnershipBarProps> = (props) => (
  <Wrapper className={props.className}>{props.children}</Wrapper>
);

export default styled(OwnershipBar)`
  justify-content: flex-start;

  .item {
    margin-right: 1px;

    .bar {
      border-radius: 24px;
    }

    ${(props) =>
      props.children.length > 2
        ? css`
            .bar {
              border-radius: 0;
            }

            &:first-child {
              .bar {
                border-radius: 24px 0 0 24px;
              }
            }
            &:last-child {
              .bar {
                border-radius: 0 24px 24px 0;
              }
            }
          `
        : null}
  }
`;

const Wrapper = styled(Flex).attrs(() => ({
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'row',
  flexShrink: '0',
}))``;
